import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  card: {
    width: 900,
    minHeight: 688,
    margin: "auto",
    padding: theme.spacing(3),
    borderRadius: theme.spacing(2),
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
  },
  title: {
    fontSize: 28,
  },
  showTitle: {
    fontSize: 16,
    fontWeight: 500,
  },
  checkbox: {
    fontSize: "14px",
    color: grey[600],
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    minHeight: 480,
    gap: theme.spacing(1),
  },
  emptyTitle: {
    fontSize: 18,
    fontWeight: 600,
    marginTop: theme.spacing(2),
  },
  emptySubtitle: {
    fontSize: 14,
    color: grey[600],
    maxWidth: 360,
  },
  taskListContainer: {
    width: "100%",
    background: "#FFFFFF",
    borderRadius: "8px",
    border: `${grey[300]} 1px solid`,
  },
  taskRow: {
    cursor: "pointer",
    width: "100%",
    minHeight: 56,
    alignItems: "stretch",
  },
  iconCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  mainCell: {
    // `minWidth: 0` lets this flex column shrink so the title can ellipsis
    // instead of a long unbroken word stretching the column over the chips.
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: theme.spacing(1, 0),
  },
  taskTitle: {
    maxWidth: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "14px",
    fontWeight: 400,
  },
  bottomLine: {
    maxWidth: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "12px",
    fontWeight: 400,
    color: grey[600],
  },
  check: {
    fill: "#4CAF50",
  },
  waitingAndWarningTodo: {
    fill: theme.palette.warning.main,
    color: theme.palette.warning.main,
  },
  overdue: {
    color: theme.palette.error.main,
  },
  todo: {
    fill: "rgba(0, 0, 0, 0.2)",
  },
  taskUpdatedStatus: {
    fontSize: theme.spacing(1.5),
    color: theme.palette.grey[600],
    letterSpacing: "0.1em",
    textTransform: "uppercase",
  },
  companyLine: {
    maxWidth: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "12px",
    color: theme.palette.text.primary,
    fontWeight: 500,
  },
  rightChipsColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: theme.spacing(0.5),
    padding: theme.spacing(1),
  },
  approvedChip: {
    fontSize: theme.spacing(1.5),
    color: "#4CAF50",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
  },
  rejectedChip: {
    fontSize: theme.spacing(1.5),
    color: theme.palette.error.main,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
  },
  // "Contains updates" — a sub-task answer moved on after the parent submit.
  // Sits inline after the task title, styled like the organiser list's own
  // label (`Tasks/styles.ts: resubmitLabel`) so the same fact looks the same
  // on both surfaces. `flexShrink: 0`: the title ellipsises, this doesn't.
  containsUpdatesChip: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    marginLeft: theme.spacing(2),
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "120%",
    whiteSpace: "nowrap",
    color: theme.palette.warning.main,
  },
  containsUpdatesIcon: {
    // Inline-sized glyph, not MUI's default 24px — it sits next to 12px text.
    fontSize: 16,
    marginRight: theme.spacing(0.5),
    color: theme.palette.warning.main,
    fill: theme.palette.warning.main,
  },
  loading: {
    margin: `${theme.spacing(3)}px auto`,
  },
}));
